


import React, { useState } from 'react'

const countries = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
  'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
  'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
  'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
  'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
  'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti',
  'Honduras', 'Hong Kong, China', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan',
  'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos',
  'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
  'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
  'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
  'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama',
  'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda',
  'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka',
  'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste',
  'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
]

export default function EditorialSignupSection() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    countryResidence: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitMessage, setSubmitMessage] = useState('')
  const [showCountryDropdown, setShowCountryDropdown] = useState(false)
  const [countryFilter, setCountryFilter] = useState('')

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleCountryInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setCountryFilter(value)
    setFormData(prev => ({
      ...prev,
      countryResidence: value
    }))
    setShowCountryDropdown(true)
  }

  const handleCountrySelect = (country: string) => {
    setFormData(prev => ({
      ...prev,
      countryResidence: country
    }))
    setCountryFilter(country)
    setShowCountryDropdown(false)
  }

  const filteredCountries = countries.filter(country =>
    country.toLowerCase().includes(countryFilter.toLowerCase())
  )

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitMessage('')

    try {
      const response = await fetch('/api/v1/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          salutation: '',
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phoneCountry: '',
          phoneNumber: '',
          countryResidence: formData.countryResidence,
          issueCategory: 'Editorial Signup',
          message: 'Signed up for editorial newsletter',
          subscribe: true,
          terms: true
        }),
      })

      if (!response.ok) {
        throw new Error('Failed to submit')
      }

      setSubmitMessage('Thank you for signing up! You will receive our editorial updates soon.')
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        countryResidence: ''
      })
    } catch (error) {
      setSubmitMessage('An error occurred. Please try again.')
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.opacity = '0.8'
  }

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.opacity = '1'
  }

  return (
    <section
      id="editorial-signup"
      className="w-full flex flex-col md:flex-row"
      style={{ minHeight: '400px' }}
    >
      {/* Image Column - square on mobile, 40% on desktop */}
      <div className="relative w-full md:w-2/5 aspect-square md:aspect-auto md:h-auto">
        <img
          src="/Editorial/Sign Up/signup.png"
          alt="Modern architecture with marina"
          className="w-full h-full object-cover"
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      </div>
      
      {/* Content Column - full width on mobile, 60% on desktop */}
      <div
        className="flex items-center justify-center w-full md:w-3/5 px-6 py-12 md:px-[75px] md:py-[69px]"
        style={{
          backgroundColor: '#EFEFEF'
        }}
      >
        <div className="w-full text-center">
          {/* Title */}
          <h2
            style={{
              fontFamily: '"FONTSPRING DEMO - The Seasons", serif',
              fontSize: '56px',
              color: '#000000',
              fontWeight: 'normal',
              marginBottom: '24px'
            }}
          >
            EDITORIAL
          </h2>
          
          {/* Description */}
          <p
            style={{
              fontFamily: 'Cardo',
              fontSize: '16px',
              color: '#000000',
              lineHeight: '1.6',
              marginBottom: '24px'
            }}
          >
            Subscribe to our editorial - a curated selection of the latest and most noteworthy in the world of luxury, delivered complimentary to your inbox.
          </p>
          
          {/* Form Fields - Stack vertically on mobile, row on desktop */}
          <form onSubmit={handleSubmit}>
            <div
              className="flex flex-col md:flex-row gap-4 md:gap-[21px] mb-6"
            >
              {/* First Name */}
              <div className="flex-1">
                <label
                  style={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '11px',
                    color: '#000000',
                    display: 'block',
                    marginBottom: '7px',
                    textAlign: 'left'
                  }}
                >
                  First name *
                </label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 px-3 py-2"
                  style={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '12px',
                    height: '40px'
                  }}
                />
              </div>

              {/* Last Name */}
              <div className="flex-1">
                <label
                  style={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '11px',
                    color: '#000000',
                    display: 'block',
                    marginBottom: '7px',
                    textAlign: 'left'
                  }}
                >
                  Last name *
                </label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 px-3 py-2"
                  style={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '12px',
                    height: '40px'
                  }}
                />
              </div>

              {/* Email */}
              <div className="flex-1">
                <label
                  style={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '11px',
                    color: '#000000',
                    display: 'block',
                    marginBottom: '7px',
                    textAlign: 'left'
                  }}
                >
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 px-3 py-2"
                  style={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '12px',
                    height: '40px'
                  }}
                />
              </div>

              {/* Country */}
              <div className="flex-1 relative">
                <label
                  style={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '11px',
                    color: '#000000',
                    display: 'block',
                    marginBottom: '7px',
                    textAlign: 'left'
                  }}
                >
                  Country of residence *
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="countryResidence"
                    value={formData.countryResidence}
                    onChange={handleCountryInputChange}
                    onFocus={() => setShowCountryDropdown(true)}
                    onBlur={() => setTimeout(() => setShowCountryDropdown(false), 200)}
                    required
                    className="w-full border border-gray-300 px-3 py-2 pr-10"
                    style={{
                      fontFamily: 'Plus Jakarta Sans',
                      fontSize: '12px',
                      height: '40px'
                    }}
                    placeholder="Select country"
                    autoComplete="new-password"
                  />
                  <div
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                  >
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L5 5L9 1" stroke="#7B7B7B" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                {showCountryDropdown && filteredCountries.length > 0 && (
                  <div
                    className="absolute top-full left-0 right-0 bg-white border border-gray-300 max-h-40 overflow-y-auto z-10"
                    style={{
                      fontFamily: 'Plus Jakarta Sans',
                      fontSize: '12px'
                    }}
                  >
                    {filteredCountries.map((country, index) => (
                      <div
                        key={index}
                        className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleCountrySelect(country)}
                      >
                        {country}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          
            {/* Sign Up Button */}
            <div className="mb-6">
              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  backgroundColor: '#000000',
                  color: '#FFFFFF',
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontSize: '16px',
                  padding: '10px 36px',
                  border: 'none',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isSubmitting ? 0.6 : 1
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {isSubmitting ? 'Signing up...' : 'Sign up'}
              </button>
            </div>

            {/* Submit Message */}
            {submitMessage && (
              <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
                {submitMessage}
              </div>
            )}

            {/* Privacy Policy Text */}
            <p
              style={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize: '10px',
                color: '#7B7B7B',
                lineHeight: '1.4'
              }}
            >
              By signing up to the newsletter you confirm you have read & agree to the Privacy Policy.
            </p>
          </form>
        </div>
      </div>
    </section>
  )
}